import { component } from 'picoapp';

const DESKTOP_MQ = '(min-width: 1024px)';

export default component(async (node) => {
  const classes = {
    active: 'faq__item--active',
  };
  const items = node.querySelectorAll('[data-item]');
  const desktopBehavior = node.dataset.desktopBehavior || 'accordion';
  const mobileBehavior = node.dataset.mobileBehavior || 'accordion';
  const mq = window.matchMedia(DESKTOP_MQ);

  const currentBehavior = () => (mq.matches ? desktopBehavior : mobileBehavior);

  const setItemOpen = (item, open) => {
    const content = item.lastElementChild;
    item.classList.toggle(classes.active, open);
    content.hidden = !open;
  };

  const applyBehavior = () => {
    const behavior = currentBehavior();
    items.forEach((item) => {
      setItemOpen(item, behavior === 'always_open');
    });
  };

  const showItem = (target) => {
    if (currentBehavior() === 'always_open') return;

    items.forEach((item) => {
      const content = item.lastElementChild;

      if (item === target) {
        item.classList.toggle(classes.active);
        content.hidden = !content.hidden;
      } else {
        item.classList.remove(classes.active);
        content.hidden = true;
      }
    });
  };

  items.forEach((item) => {
    const title = item.firstElementChild;

    title.addEventListener('click', () => {
      showItem(item);
    });
  });

  applyBehavior();

  const onChange = () => applyBehavior();
  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else mq.addListener(onChange);
});
